<template>
  <div class="bg-white bg-kekkle-pattern bg-repeat">
    <div
      class="flex-col bg-white bg-opacity-[97%] dark:bg-kekkle-dark dark:bg-opacity-[99%]"
    >
      <router-view />
    </div>
  </div>
  <navigation-bar v-if="groupData"></navigation-bar>

  <!-- Member Profile Bottom Sheet -->
  <member-profile-bottom-sheet
    v-model:open="isOpen"
    :member-id="selectedMemberId"
  ></member-profile-bottom-sheet>
</template>

<script>
import NavigationBar from "../components/NavigationBar.vue";
import MemberProfileBottomSheet from "../components/MemberProfileBottomSheet.vue";
import { useGroupsStore } from "@/stores/modules/groups/groups";
import { useMemberProfile } from "@/composables/useMemberProfile";

export default {
  name: "NavigationLayout",
  components: { NavigationBar, MemberProfileBottomSheet },
  setup() {
    const groupsStore = useGroupsStore();
    const { isOpen, selectedMemberId } = useMemberProfile();
    return { groupsStore, isOpen, selectedMemberId };
  },
  computed: {
    groupData() {
      return this.groupsStore.groupData;
    },
  },
};
</script>
